import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { FlightLogHttpClient } from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.service';
import { FlightLogEntity } from 'src/store/flight-log/flight-log.model';
import { filterNull } from 'src/util/rxjs/operators';

@Component({
  selector: 'fl-edit-flight-log-page',
  templateUrl: './edit-flight-log-page.component.html',
  styleUrls: ['./edit-flight-log-page.component.scss'],
})
export class EditFlightLogPageComponent implements OnInit {
  public id$: Observable<string>;
  public flightLog$: Observable<FlightLogEntity>;
  public lastSave$ = new BehaviorSubject<Date | undefined>(undefined);
  public saving: boolean;
  public error: boolean;
  public showSaveIndicator$: Observable<boolean>;

  constructor(route: ActivatedRoute, private flightLogs: FlightLogHttpClient) {
    this.id$ = route.params.pipe(map((_) => _.id));
  }

  public ngOnInit() {
    this.flightLog$ = this.id$.pipe(
      switchMap((id) => this.flightLogs.getById(id)),
      filterNull(),
    );
    this.showSaveIndicator$ = this.flightLog$.pipe(
      map((flightLog) => {
        return flightLog.status !== 'Complete';
      }),
    );
  }
}
